/* ***************************************
This mixin "exposes" the methods:
  * rewriteWordOrWordsInWorkingArrayMethod() [for EditNikudPane, ManualNikudPane, NikudOptionsPane, NikudEdit]
  * spliceWordsInWorkingArrayMethod() [for EditNikudPane]
  * changeAllAlikeWordsToNewNikud() [for ManualNikudPane and NikudOptionsPane]
It has the "common dependency" methods:
  * rewriteWordOrWordsInWorkingArrayMethod() [exposed (as above), AND used by the resultsIntegrationMixins method
                                        clearNikudEffectiveImmediately(), which is both "exposed" (for
                                        NikudEdit) AND used by its own internal method
                                        getWordsArrayFromNakdanResponse(), in turn used by its own methods
                                        populateAllWorkingNikud() (used by NikudEdit) and 
                                        finishEditingWordGroup() (used by EditNikudPane and ManualNikudPane)]
  * spliceWordsInWorkingArrayMethod() [exposed (as above), AND used by the resultsIntegrationMixins method
                                        finishEditingWordGroup() (used by EditNikudPane and ManualNikudPane)]
(all else should be considered "internal")
*************************************** */
import {applySpecialNikud} from '@/js/specialNikud'
// import {getChosenWordString} from '../js/letterOperations';

export default {
  name: 'wordMutatingMixins',
  methods: {
    rewriteWordOrWordsInWorkingArrayMethod (commitObjectOrObjects) {
      const commitObjects = Array.isArray(commitObjectOrObjects) ? commitObjectOrObjects : [commitObjectOrObjects]
      commitObjects.forEach(commitObj => {
        var newWord = JSON.parse(JSON.stringify(
          this.$store.state.allWorkingNikud.wordsArray[commitObj.newWordContainer.index])) // deep copy
        Object.assign(newWord, commitObj.newWordContainer.changes) // simulate the manual changes
        var nextWordIndex = commitObj.newWordContainer.index + 1
        var nextWord = (nextWordIndex < this.$store.state.allWorkingNikud.wordsArray.length)
          ? this.$store.state.allWorkingNikud.wordsArray[nextWordIndex] : null      
        var changesObjs = applySpecialNikud(this.$store.state, 'word-mutating', newWord, nextWord)
        // console.log('getChosenWordString(newWord):')
        // console.log(getChosenWordString(newWord))
        // console.log('changesObjs:')
        // console.log(changesObjs)
        Object.assign(commitObj.newWordContainer.changes, changesObjs.mainWord)
        // console.log('changesObjs.otherWord:')
        // console.log(changesObjs.otherWord)
        if (Object.keys(changesObjs.otherWord).length) {
          commitObj['nextWordContainer'] = {
            index: nextWordIndex,
            changes: changesObjs.otherWord
          }
        }
        // console.log('commitObj:')
        // console.log(commitObj)
        this.$store.commit('REWRITE_WORD_IN_WORKING_ARRAY', commitObj)
        this.modesObj.wordMutationCount += 1 // so panes can re-initialize
      })
    },
    spliceWordsInWorkingArrayMethod (commitObj) {
      const lastWord = commitObj.spliceWordsContainer.spliceWordsArray.length
        ? commitObj.spliceWordsContainer.spliceWordsArray[commitObj.spliceWordsContainer.spliceWordsArray.length - 1]
        : (commitObj.spliceWordsContainer.startIndex > 0 
          ? this.$store.state.allWorkingNikud.wordsArray[commitObj.spliceWordsContainer.startIndex - 1] : null)
      const nextWordIndex = commitObj.spliceWordsContainer.startIndex + commitObj.spliceWordsContainer.toDelete
      var nextWord = (nextWordIndex < this.$store.state.allWorkingNikud.wordsArray.length)
        ? this.$store.state.allWorkingNikud.wordsArray[nextWordIndex] : null      
      if (lastWord && nextWord) {
        var changesObjs = applySpecialNikud(this.$store.state, 'word-mutating', lastWord, nextWord)
        // for now, assuming 'lastWord' won't need changes in this case
        if (Object.keys(changesObjs.otherWord).length) {
          commitObj['nextWordContainer'] = {
            index: nextWordIndex - commitObj.spliceWordsContainer.toDelete, 
            changes: changesObjs.otherWord
          }
        }
      }
      // console.log('commitObj:')
      // console.log(commitObj)
      this.$store.commit('SPLICE_WORDS_IN_WORKING_ARRAY', commitObj)
      this.modesObj.wordMutationCount += 1 // so panes can re-initialize
    },
    changeAllAlikeWordsToNewNikud () {
      const wordsToChange = this.getAllAlikeWordsToChange()
      if (wordsToChange.length) this.rewriteWordOrWordsInWorkingArrayMethod(wordsToChange)
      this.showApplyToAllPopup = false
      return wordsToChange.length
    }
  }
}
